import ApiService from "../api.service";
import appConfig from "../../../app-config";

ApiService.init(appConfig.VUE_APP_ROOT_API);

const InvoiceCreditService = {
  getProductBatches(filter, params) {
    const requestScreenData = {
      url: "api/InvoiceProductBatch",
      filter: filter,
    };

    if (params) {
      if (params.select) {
        requestScreenData.select = params.select;
      }
    }

    return ApiService.oDataGet(requestScreenData);
  },

  async saveInvoiceCredit(payload) {
    var url = "api/Save_Invoice";

    return await ApiService.post(url, payload);
  },


  async getActiveAccountingPeriodStartDate() {
    const requestScreenData = {
      url: "api/ActiveAccountingPeriod",
      top: "1",
      filter: `PeriodType eq 'AR'`,
      orderby: "StartDate",
      select: ["StartDate", "EndDate", "PeriodType"]
    };

    return await ApiService.oDataGet(requestScreenData);
  },
  async getActiveAccountingPeriodEndDate() {
    const requestScreenData = {
      url: "api/ActiveAccountingPeriod",
      top: "1",
      filter: `PeriodType eq 'AR'`,
      orderby: "EndDate desc",
      select: ["StartDate", "EndDate", "PeriodType"]
    };

    return await ApiService.oDataGet(requestScreenData);
  },

  async getInvoiceById(id) {
    const requestScreenData = {
      url: "api/Invoice",
      top: "1",
      filter: `Code eq ${id}`,
      select: ["Code", "DeliveryNoteCode"]
    };

    return await ApiService.oDataGet(requestScreenData);
  }
};

export { InvoiceCreditService };
